export default __webpack_public_path__ + "static/media/safepal-sfp.fb953867.svg";